<template>
  <div class="my-header w">
    <!-- 上面区域 -->
<!--    <div class="header-top">-->
<!--      &lt;!&ndash; logo &ndash;&gt;-->
<!--      <h1 class="logo">-->
<!--        <router-link to="/">-->

<!--          <img src="../assets/logo2.png">-->
<!--        </router-link>-->
<!--      </h1>-->
<!--      &lt;!&ndash; 搜索&ndash;&gt;-->
<!--      <div class="center">-->
<!--        <div class="center-search">-->
<!--          <input type="text" v-model="name" name id placeholder="请输入名称搜索..." />-->
<!--          <button @click="jump(`${name}`)" class="search-btn">搜索</button>-->

<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <!-- 分类导航 -->
    <AppHeaderNav />
  </div>
</template>

<script>
import AppHeaderNav from "./AppHeaderNav.vue";
import { useStore } from "vuex";
import {useRouter} from 'vue-router'
import {ref} from 'vue'


export default {
  components: {
    AppHeaderNav
  },
  setup(props) {
    // const store = useStore();
    // // 触发action
    // store.dispatch('category/getAllCategory');

    const name = ref('')

    const router=useRouter()
    router.removeRoute("/patent")
    const jump=(e)=>{

      let result= "/patent"
      // router.push(result)
      router.push({ path: '/patent', query: { name: e } });

    }
    return {jump,name}
  }
};
</script>

<style lang="less" scoped>
.my-header {
  height: 60px;
  padding: 20px 0 0 0;
  background-color: #fff;
  .header-top {
    display: flex;
    .logo {
      width: 375px;
      height: 60px;
      background-color: @xtxColor;

      a {
        display: inline-block;
        height: 60px;
        width: 100%;
        img{

          height: 60px;
        }
      }

    }
    .center {
      flex: 1;
      padding-left:50px;
      display: flex;align-items: center;
      .center-search {
        width: 540px;
        height: 35px;
        input {
          width: 440px;
          height: 35px;
          border: 1px solid @xtxColor;
          border-radius: 20px 0 0 20px;
          padding-left: 15px;
          box-sizing: border-box;
        }
        .search-btn {
          float: right;
          width: 100px;
          height: 35px;
          color: #fff;
          background-color: @xtxColor;
          border-radius: 0 20px 20px 0;
          border: 0;
          font-size: 16px;
          cursor: pointer;
        }
      }

    }

  }
}
</style>